import classNames from 'classnames';
import { FC, useState, MouseEvent } from 'react';

import type { SubCategoryArticle } from '@/entities/article';
import { ArticleSubCategoryItem } from '@/features/article';

import styles from './articleSubCategoryList.module.scss';

interface ArticleSubCategoryListProps {
  value: SubCategoryArticle[];
  className?: string;
  parentDisplayCount?: number;
}

const ArticleSubCategoryList: FC<ArticleSubCategoryListProps> = (props) => {
  const { value, className, parentDisplayCount } = props;
  const [activeItemId, setActiveItemId] = useState<number | null>(null);

  const handleItemClick = (e: MouseEvent, id: number) => {
    e.stopPropagation();
    setActiveItemId((prev) => (prev === id ? null : id));
  };

  function renderItem(article: SubCategoryArticle, index: number) {
    const isActive = activeItemId === article.id;

    return (
      <li
        key={article.id}
        className={styles.list__item}
        onClick={(e) => handleItemClick(e, article.id)}
      >
        <ArticleSubCategoryItem
          index={index + 1}
          isActive={isActive}
          parentDisplayCount={parentDisplayCount}
          value={article}
        />
      </li>
    );
  }
  return (
    <>
      <ul className={classNames(className, styles.list)}>
        {value?.map(renderItem)}
      </ul>
    </>
  );
};

export default ArticleSubCategoryList;
